const ErrorText = ({ message }) => (
  <>
  {message&& <p className="text-red-500 text-sm mt-1">  {message?.charAt(0).toUpperCase() + message?.slice(1)}</p>}
  </>
);
export default ErrorText